class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.menuTabs = this.querySelectorAll('.mega-menu-tabs>li');
    this.menuTabContent = this.querySelectorAll('.mega-menu-tab-content>ul');
    this.bannerItems = this.querySelectorAll(
      '.custom-content .banner-item[data-parent]',
    );
    this.brandsWithBanner = this.querySelectorAll(
      '.custom-content .block-brands-with-banner[data-parent]',
    );
  }

  connectedCallback() {
    this.initMenuTab();
    this.activeBannerCount();
  }

  initMenuTab() {
    this.menuTabs.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        const target = item.getAttribute('data-handle');

        // Remove active from all tabs and contents
        this.menuTabs.forEach((el) => el.classList.remove('active'));
        this.menuTabContent.forEach((el) => el.classList.remove('active'));
        this.bannerItems.forEach((el) => el.classList.remove('active'));
        this.brandsWithBanner.forEach((el) => el.classList.remove('active'));

        item.classList.add('active');

        const content = this.querySelector(
          `.mega-menu-tab-content ul[data-parent="${target}"]`,
        );
        const targetBannerItems = this.querySelectorAll(
          `.custom-content .banner-item[data-parent="${target}"]`,
        );
        const targetBrandsWithBanners = this.querySelectorAll(
          `.custom-content .block-brands-with-banner[data-parent="${target}"]`,
        );
        if (content) {
          content.classList.add('active');
        }
        targetBannerItems.forEach((item) => {
          item.classList.add('active');
        });
        targetBrandsWithBanners.forEach((item) => {
          item.classList.add('active');
        });
      });
    });
  }
  activeBannerCount() {
    const activeBannerItem = this.querySelectorAll(
      '.custom-content .banner-item.active[data-parent]',
    ).length;
    const parentElement = this.bannerItems[0]?.closest('.custom-content');
    if (activeBannerItem > 0 && parentElement) {
      this.bannerItems[0]
        ?.closest('.custom-content')
        .classList.add(`baner-count-${activeBannerItem}`);
    }
  }
}

customElements.define('header-menu', HeaderMenu);
